export enum FeatureTypes {
    ICES = 1,
    Factory,
    Releases,
    Recaptures,
    Catches
}